export const FEATURE_FLAGS = {
  ANNUAL_APPRAISALS_ENABLED: false
};

export const isAnnualAppraisalsEnabled = () => FEATURE_FLAGS.ANNUAL_APPRAISALS_ENABLED;

/** Drop inbox rows for modules hidden by feature flags. */
export const filterInboxItemsWithoutDisabledFeatures = (rows) => {
  const list = Array.isArray(rows) ? rows : [];
  if (isAnnualAppraisalsEnabled()) {
    return list;
  }
  return list.filter((row) => String(row?.object_type || '') !== 'annual_appraisal');
};
